export default {
    accessibilityLabel: 'Fil d’Ariane',
};
